import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

/**
 * @method apiRequestOTP
 * @method apiLogin
 * @method apiLogout
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * Request OTP
     * @param {Object} authRequestOTPParams AuthRequestOTPModel.getParams() /service/config/AuthConfigModel.js
     */
    apiRequestOTP: function (contactNumber, channel) {
        console.log(contactNumber, channel);
        const params = {
            contact_number: contactNumber,
            app_id: this.config().client_id,
            // uuid: uuid,
            channel: channel, //"authen" flow update tel use "contact_number"
        };
        // authRequestOTPParams.app_id = this.config().client_id;
        var url = this.config().bzbsUrl + "/auth/otp";
        return BzbsApi.connectBzbsGet(url, null, params);
    },
    // requestOtp: function(contactNumber, channel, uuid) {
    //     const params = {
    //         contact_number: contactNumber,
    //         app_id: ConfigManager.getAppId(),
    //         uuid: uuid,
    //         channel: channel, //"authen" flow update tel use "contact_number"
    //     };

    //     const url = ConfigManager.getApiUrl() + "/auth/otp";
    //     return BzbsApi.connectBzbsGet(url, null, params).pipe(map(res => res.data));
    // },
    /**
     * @param {String} username
     * @param {String} password
     * @param {String} strUUID
     * @param {String} strDeviceToken
     * @param {String} strClientVersion
     * @param {Boolean} isDeviceNotiEnable
     */
    apiLoginBzb: function(username, password, strUUID, strDeviceToken, strClientVersion, isDeviceNotiEnable) {
        var params = {
            username: username,
            password: password,
            uuid: strUUID,
            app_id: this.config().client_id,
            os: "web",
            platform: "web",
            mac_address: strUUID,
            device_noti_enable: isDeviceNotiEnable,
            client_version: strClientVersion,
            device_token: strDeviceToken,
        };

        var url = this.config().bzbsUrl + "/auth/bzbs_login";
        return BzbsApi.connectBzbsPost(url, null, params);
    },
    apiLoginDevice: function (params) {
        params.app_id = this.config().client_id;
        var url = this.config().bzbsUrl + "/auth/device_login";
        return BzbsApi.connectBzbsPost(url, null, params);
    },
    /**
     * @param {String} strBzbsToken
     * @param {String} strFBToken
     * @param {String} strUUID
     */
    apiLogout: function(strBzbsToken, strFBToken, strUUID) {
        var params = {
            uuid: strUUID,
            access_token: strFBToken,
        };

        var url = this.config().bzbsUrl + "/auth/logout";
        return BzbsApi.connectBzbsPost(url, strBzbsToken, params);
    },

    /**
     * @param {string} lineIdToken
     */
    apiLoginLine: function(lineIdToken) {
        var params = {
            app_id: this.config().client_id,
            id_token: lineIdToken,
            device_locale: 1054
        };
        var url = this.config().bzbsUrl + "/auth/line_login";
        return BzbsApi.connectBzbsPost(url, null, params);
    },

    /**
     * Create AccessKey for send to another website
     * @param {String} token
     * @param {String} payload Payload for keep value, string json format
     */
    apiCreateAccessKey: function (token, payload) {
        let params = {
            data: payload
        }
        let url = this.config().bzbsUrl + '/setting'
        return BzbsApi.connectBzbsPost(url, token, params, null, null, true);
    },
}
